import { render, staticRenderFns } from "./Tarifarios.vue?vue&type=template&id=3fa5fcb5"
import script from "./Tarifarios.vue?vue&type=script&lang=js"
export * from "./Tarifarios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports